import React, { Component } from "react";
// import ReactVivus from "react-vivus";
import svgSydle from "../../svg/orbita-sydle-one.svg";
import NavBar from "../../components/navBar";
import WhatsappButton from "../../components/whatsappButton";
import Footer from "../../components/footer";
import Metatags from "../../components/metatags";
import { Link as Scroll, scroller } from "react-scroll";
import Rellax from "react-rellax";
import Card from "../../components/cards/card.js";
import ScrollTop from "../../components/scroll-top/scrollTop";
import Customers from "./sections/customers.js";

import en from "../../resources/en/home.js";
import br from "../../resources/br/home.js";
import es from "../../resources/es/home.js";

import routeNamesBr from "../../resources/br/routeNames.js";
import routeNamesEn from "../../resources/en/routeNames.js";
import routeNamesEs from "../../resources/es/routeNames.js";

import Location from "../../utils/location-servicefacade.js";
import Vivus from "vivus";

class Home extends Component {
  constructor(props) {
    super(props);
    this.textsHome = { en: en, br: br, es: es }; // Textos da página de acordo com a linguagem
    this.routeNames = { en: routeNamesEn, br: routeNamesBr, es: routeNamesEs }; // Nomes de rotas de acordo com a linguagem
    let storedLang = JSON.parse(localStorage.getItem("language"));
    const availableLanguages =
      process.env.REACT_APP_AVAILABLE_LANGUAGES.split(" ");
    this.currentLanguage =
      storedLang && availableLanguages.includes(storedLang.lang)
        ? storedLang.lang
        : process.env.REACT_APP_DEFAULT_LANGUAGE;
    this.state = {
      showContactModal: false,
      geolocationStatus: false,
      language: this.currentLanguage,
      locationService: new Location(),
    };

    /*
     * Evita que seja chamada a API de localização ou que seja modificado um estado enquanto o componente
     * não está montado
     */
    this._isMounted = false;
  }

  // Início dos métodos de localização

  // Seta localização e obtem linguagem após o usuário permitir a geolocalização
  locationPermitted = (position) => {
    this.state.locationService.getLang(this.setLanguage);
    if (position.coords) {
      localStorage.setItem(
        "location",
        JSON.stringify([position.coords.longitude, position.coords.latitude])
      );
    }
  };

  // Seta a linguagem como a padrão ou armazenada no local storage após o usuário negar a localização
  locationDenied = (positionError) => {
    let storedLang = JSON.parse(localStorage.getItem("language"));
    const availableLanguages =
      process.env.REACT_APP_AVAILABLE_LANGUAGES.split(" ");
    let currentLanguage =
      storedLang && availableLanguages.includes(storedLang.lang)
        ? storedLang.lang
        : process.env.REACT_APP_DEFAULT_LANGUAGE;
    this._isMounted && this.setState({ language: currentLanguage });
    let url = window.location.pathname;
    let urlLang = url.split("/")[1];
    this.props.history.push(url.replace(urlLang, currentLanguage));
    console.log(positionError.message);
  };

  // Seta a linguagem após o usuário permitir a localização
  setLanguage = (userLang) => {
    let storedLang = JSON.parse(localStorage.getItem("language"));
    if (!storedLang.isLocated) {
      this._isMounted && this.setState({ language: userLang });
      localStorage.setItem(
        "language",
        JSON.stringify({ lang: this.state.language, isLocated: true })
      ); // Salva linguagem no local storage a partir da localização
      let url = window.location.pathname;
      let urlLang = url.split("/")[1];
      if (urlLang !== this.state.language) {
        this.setHistory(this.state.language);
        window.location.reload();
      }
    }
  };

  // Inicia a cadeia de métodos de localização e linguagem
  setLocation = () => {
    this._isMounted &&
      this.state.locationService.setGeoLocation(
        this.locationPermitted,
        this.locationDenied
      );
  };
  // Fim dos métodos de localização

  // Altera a url atual de acordo com a linguagem atual
  setUrlLanguage = () => {
    let urlLang = window.location.pathname.split("/")[1];
    if (urlLang) {
      let storedLang = JSON.parse(localStorage.getItem("language"));
      localStorage.setItem(
        "language",
        JSON.stringify({
          lang: urlLang,
          isLocated: storedLang ? storedLang.isLocated : false,
        })
      );
      this._isMounted && this.setState({ language: urlLang });
    }
  };

  componentDidMount() {
    this._isMounted = true;
    if (this._isMounted) {
      if (
        this.props.history.location.state &&
        this.props.history.location.state.otherPage
      ) {
        scroller.scrollTo("lev-section-pricing", {
          duration: 1000,
          // delay: 500,
          smooth: true,
          offset: 42,
        });
        this.props.history.replace("", null);
      }

      this.setLocation();
      this.setUrlLanguage();

      if (window.location.pathname !== "/") {
        // Inicializa animação svg somente após redirect da linguagem
        new Vivus("vivus-div", {
          duration: 100,
          file: svgSydle,
          type: "delayed",
        });
      }
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  handleClickContact = () => {
    let lang;
    let storedLang = JSON.parse(localStorage.getItem("language"));
    const availableLanguages =
      process.env.REACT_APP_AVAILABLE_LANGUAGES.split(" ");
    lang =
      storedLang && availableLanguages.includes(storedLang.lang)
        ? storedLang.lang
        : process.env.REACT_APP_DEFAULT_LANGUAGE;
    this.props.history.push("/" + lang + "/" + this.routeNames[lang].contato);
  };

  setHistory = (lang) => {
    this.props.history.push("/" + lang);
    this.setUrlLanguage(lang);
  };

  render() {
    const links = [
      {
        label: "Carreiras",
        link: "/carreiras",
      },
    ];

    const rightButton = {
      label: this.textsHome[this.state.language].button.contact,
      onClick: this.handleClickContact,
      color: "light",
    };

    return (
      <>
        <Metatags
          title={this.textsHome[this.state.language].home.title}
          description={this.textsHome[this.state.language].home.description}
          url={window.location.href}
          canonical=""
          language={this.state.language}
        />
        <NavBar
          links={links}
          rightButton={rightButton}
          language={this.state.language}
          showWhatsappButton={true}
          changeCollor={true}
        />

        <main>
          <section className="notranslate lev-section-hero animated fadeIn slow" id="start">
            <span className="notranslate lev-section-hero-bg"></span>
            <span className="notranslate lev-section-hero-img-lg-xl"></span>
            <Rellax className="notranslate lev-geometric-shape lev-geometric-shape-1 rellax" />
            <div className="notranslate container">
              <div className="notranslate row">
                <div className="notranslate col-sm-9 col-md-11 col-lg-9 col-xl-7">
                  <h1 className="notranslate mb-4 d-sm-none">
                    {this.textsHome[this.state.language].specializedTeams.title}
                  </h1>
                  {/*Parece não estar sendo utilizado*/}
                  <h1 className="notranslate mb-4 pb-lg-2 d-none d-sm-block">
                    {this.textsHome[this.state.language].specializedTeams.title}
                  </h1>
                  <p className="notranslate lead mb-4 pb-lg-2">
                    {
                      this.textsHome[this.state.language].specializedTeams
                        .description
                    }
                  </p>

                  <Scroll
                    className="notranslate btn btn-lg btn-primary btn-white-text d-none d-lg-inline-block"
                    to="saiba-mais"
                    duration={1100}
                    smooth={true}
                  >
                    {this.textsHome[this.state.language].button.learnMore}
                  </Scroll>
                </div>
              </div>
            </div>
            <img
              className="notranslate lev-section-hero-img-xs w-100 d-sm-none"
              src="/images/illustrations/team-xs.svg"
              alt=""
            />
            <img
              className="notranslate lev-section-hero-img-sm-md d-none d-sm-block d-lg-none"
              src="/images/illustrations/team-sm-md.svg"
              alt=""
            />
          </section>

          <section className="notranslate lev-section-taas" id="saiba-mais">
            <div className="notranslate container">
              <div className="notranslate row">
                <div className="notranslate col-sm-9 col-lg-5 col-xl-4">
                  <h2
                    
                      translate="no"
                    className="notranslate h1 mb-4 d-lg-none"
                  >
                    {this.textsHome[this.state.language].teamAsService.title}
                  </h2>
                  {/*Parece não estar sendo utilizado*/}
                  <h2
                    
                      translate="no"
                    className="notranslate h1 mb-4 pb-2 d-none d-lg-block"
                  >
                    {this.textsHome[this.state.language].teamAsService.title}
                  </h2>
                  <p    translate="no" className="notranslate mb-0 lead">
                    {
                      this.textsHome[this.state.language].teamAsService
                        .description
                    }
                  </p>
                </div>
              </div>
            </div>
          </section>

          <section className="notranslate lev-section-managment-flex">
            <span className="notranslate lev-section-feature-bg"></span>
            <Rellax className="notranslate lev-geometric-shape lev-geometric-shape-2 rellax" />
            <div className="notranslate container">
              <div className="notranslate row">
                <div className="notranslate col-md-8 col-md-12 col-lg-4">
                  <h1 className="notranslate mb-4 pb-lg-2">
                    {this.textsHome[this.state.language].management.title}
                  </h1>
                  <p className="notranslate lead mb-5 mb-lg-0">
                    {this.textsHome[this.state.language].management.description}
                  </p>
                </div>

                <div className="notranslate col col-lg-6 ml-auto">
                  <div className="notranslate lev-section-feature-row">
                    <div className="notranslate lev-section-feature-item">
                      <div className="notranslate lev-section-feature-icon">
                        <img
                          src="/images/icons/trending_up.svg"
                          alt=""
                          width="24"
                          height="24"
                        />
                      </div>
                      <h3 className="notranslate mb-3">
                        {
                          this.textsHome[this.state.language].management
                            .features[0].title
                        }
                      </h3>
                      <p>
                        {
                          this.textsHome[this.state.language].management
                            .features[0].description
                        }
                      </p>
                    </div>
                    <div className="notranslate lev-section-feature-item">
                      <div className="notranslate lev-section-feature-icon">
                        <img
                          src="/images/icons/attach_money.svg"
                          alt=""
                          width="24"
                          height="24"
                        />
                      </div>
                      <h3 className="notranslate mb-3">
                        {
                          this.textsHome[this.state.language].management
                            .features[1].title
                        }
                      </h3>
                      <p>
                        {
                          this.textsHome[this.state.language].management
                            .features[1].description
                        }
                      </p>
                    </div>
                  </div>
                  <div className="notranslate lev-section-feature-row">
                    <div className="notranslate lev-section-feature-item">
                      <div className="notranslate lev-section-feature-icon">
                        <img
                          src="/images/icons/group.svg"
                          alt=""
                          width="24"
                          height="24"
                        />
                      </div>
                      <h3 className="notranslate mb-3">
                        {
                          this.textsHome[this.state.language].management
                            .features[2].title
                        }
                      </h3>
                      <p>
                        {
                          this.textsHome[this.state.language].management
                            .features[2].description
                        }
                      </p>
                    </div>
                    <div className="notranslate lev-section-feature-item">
                      <div className="notranslate lev-section-feature-icon">
                        <img
                          src="/images/icons/school.svg"
                          alt=""
                          width="24"
                          height="24"
                        />
                      </div>
                      <h3 className="notranslate mb-3">
                        {
                          this.textsHome[this.state.language].management
                            .features[3].title
                        }
                      </h3>
                      <p className="notranslate m-0">
                        {
                          this.textsHome[this.state.language].management
                            .features[3].description
                        }
                      </p>
                    </div>
                  </div>
                  <div className="notranslate lev-section-feature-row">
                    <div className="notranslate lev-section-feature-item">
                      <div className="notranslate lev-section-feature-icon">
                        <img
                          src="/images/icons/search.svg"
                          alt=""
                          width="24"
                          height="24"
                        />
                      </div>
                      <h3 className="notranslate mb-3">
                        {
                          this.textsHome[this.state.language].management
                            .features[4].title
                        }
                      </h3>
                      <p>
                        {
                          this.textsHome[this.state.language].management
                            .features[4].description
                        }
                      </p>
                    </div>
                    <div className="notranslate lev-section-feature-item">
                      <div className="notranslate lev-section-feature-icon">
                        <img
                          src="/images/icons/autorenew.svg"
                          alt=""
                          width="24"
                          height="24"
                        />
                      </div>
                      <h3 className="notranslate mb-3">
                        {
                          this.textsHome[this.state.language].management
                            .features[5].title
                        }
                      </h3>
                      <p>
                        {
                          this.textsHome[this.state.language].management
                            .features[5].description
                        }
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>                      
                 
          <Customers language={this.state.language} />           

          <section className="notranslate lev-section-pricing mt-1">
            <div className="notranslate container">
              <div className="notranslate row justify-content-center">
                <div className="notranslate col-sm-11 col-md-12 col-lg-9 text-sm-center">
                  <h2 className="notranslate h1 mb-4 pb-lg-2">
                    {this.textsHome[this.state.language].teamsModels.title}
                  </h2>
                  <p className="notranslate lead mb-0">
                    {
                      this.textsHome[this.state.language].teamsModels
                        .description
                    }
                  </p>
                </div>
              </div>
              <div className="notranslate lev-card-deck row row-cols-1 row-cols-lg-3">
                <div className="notranslate col mb-3">
                  <Card
                    title={
                      this.textsHome[this.state.language].teamsModels.packs[0]
                        .title
                    }
                    subtitle={
                      this.textsHome[this.state.language].teamsModels.packs[0]
                        .description
                    }
                    items={[
                      this.textsHome[this.state.language].teamsModels.packs[0]
                        .scrum,
                      this.textsHome[this.state.language].teamsModels.packs[0]
                        .dev,
                    ]}
                  />
                </div>
                <div className="notranslate col mb-3">
                  <Card
                    title={
                      this.textsHome[this.state.language].teamsModels.packs[1]
                        .title
                    }
                    subtitle={
                      this.textsHome[this.state.language].teamsModels.packs[1]
                        .description
                    }
                    items={[
                      this.textsHome[this.state.language].teamsModels.packs[1]
                        .scrum,
                      this.textsHome[this.state.language].teamsModels.packs[1]
                        .devLead,
                      this.textsHome[this.state.language].teamsModels.packs[1]
                        .dev,
                    ]}
                  />
                </div>
                <div className="notranslate col mb-3">
                  <Card
                    title={
                      this.textsHome[this.state.language].teamsModels.packs[2]
                        .title
                    }
                    subtitle={
                      this.textsHome[this.state.language].teamsModels.packs[2]
                        .description
                    }
                    items={[
                      this.textsHome[this.state.language].teamsModels.packs[2]
                        .scrum,
                      this.textsHome[this.state.language].teamsModels.packs[2]
                        .devLead,
                      this.textsHome[this.state.language].teamsModels.packs[2]
                        .dev,
                    ]}
                  />
                </div>
              </div>
              {/* <div className="notranslate d-flex justify-content-center">
                <LevtyButton label="Conheça nossos planos" onClick={() => this.props.history.push("/planos")} />
              </div> */}
            </div>
          </section>

          <section className="notranslate lev-section-technology">
            <div className="notranslate container">
              <div className="notranslate row justify-content-between">
                <div className="notranslate col-lg-4">
                  <h2 className="notranslate h1 mb-4 pb-lg-2">
                    {this.textsHome[this.state.language].ourTechnology.title}
                  </h2>
                  <p className="notranslate lead mb-4 pb-2">
                    {
                      this.textsHome[this.state.language].ourTechnology
                        .description
                    }
                  </p>
                  <div className="notranslate row">
                    <div className="notranslate col-4 col-lg-5">
                      <ul>
                        <li className="notranslate with-icon card-text-left">
                          {
                            this.textsHome[this.state.language].ourTechnology
                              .bpm
                          }
                        </li>
                        <li className="notranslate with-icon card-text-left">
                          {
                            this.textsHome[this.state.language].ourTechnology
                              .ecm
                          }
                        </li>
                        <li className="notranslate with-icon card-text-left">
                          {
                            this.textsHome[this.state.language].ourTechnology
                              .crm
                          }
                        </li>
                        <li className="notranslate with-icon card-text-left">
                          {
                            this.textsHome[this.state.language].ourTechnology
                              .billing
                          }
                        </li>
                      </ul>
                    </div>
                    <div className="notranslate col-8 col-lg-7">
                      <ul>
                        <li className="notranslate with-icon card-text-left">
                          {
                            this.textsHome[this.state.language].ourTechnology
                              .ecommerce
                          }
                        </li>
                        <li className="notranslate with-icon card-text-left">
                          {
                            this.textsHome[this.state.language].ourTechnology
                              .servicedesk
                          }
                        </li>
                        <li className="notranslate with-icon card-text-left">
                          {
                            this.textsHome[this.state.language].ourTechnology
                              .powerManagement
                          }
                        </li>
                        <li className="notranslate with-icon card-text-left">
                          {
                            this.textsHome[this.state.language].ourTechnology
                              .analytics
                          }
                        </li>
                      </ul>
                    </div>
                  </div>
                  <a
                    className="notranslate btn btn-lg btn-link pl-0 partner-sydle"
                    href="https://www.sydle.com/"
                    target="blank"
                    rel="noopener"
                  >
                    <img
                      className="notranslate mr-2"
                      src="/images/icons/remove.svg"
                      alt=""
                      width="24"
                      height="24"
                    />
                    <span className="notranslate ml-1">
                      {this.textsHome[this.state.language].button.learnMore}
                    </span>
                  </a>
                </div>
                <div className="notranslate col-lg-6 mt-5 mt-sm-0">
                  <div id="vivus-div"></div>
                  {/* <ReactVivus
                    id="foo"
                    option={{
                      file: svgSydle,
                      animTimingFunction: 'linear',
                      type: 'delayed'
                    }}
                    callback={() => { }}
                  />*/}
                </div>
              </div>
            </div>
          </section>

          <section className="notranslate lev-section-choose-your-team">
            <div className="notranslate container">
              <div className="notranslate row justify-content-center text-sm-center">
                <div className="notranslate col-lg-8">
                  <h2 className="notranslate h1 mb-4 pb-lg-2">
                    {this.textsHome[this.state.language].buildTeam.title}
                  </h2>
                </div>
                <div className="notranslate col-lg-7">
                  <p className="notranslate lead mb-4 pb-md-2 mx-auto">
                    {this.textsHome[this.state.language].buildTeam.description}
                  </p>
                  <button
                    className="notranslate btn btn-lg btn-primary btn-white-text"
                    onClick={this.handleClickContact}
                  >
                    {this.textsHome[this.state.language].button.contact}
                  </button>
                </div>
              </div>
            </div>
          </section>

          {/* <ContactModal handleContactModal={this.handleContactModal} showContactModal={showContactModal} /> */}
        </main>

        <WhatsappButton language={this.state.language} />

        <ScrollTop />
        <Footer
          language={this.state.language}
          setHistory={this.setHistory}
          hasTranslation={true}
        />
      </>
    );
  }
}

export default Home;
